<template>
  <div class="bottom-nav">
    <ul class="nav-list">
      <li
        :class="{ active: active == item.id }"
        v-for="(item, i) in list"
        :key="i"
        @click="jumpPage(item.url, true)"
      >
        <i class="icon" :class="'icon' + item.id"></i>
        <div>{{ item.name }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { common } from "@/api/mixins";
export default {
  mixins: [common],
  data() {
    return {
      load: false,
      list: [
        { name: "首页", url: "/app/index", id: "1" },
        { name: "我的", url: "/app/my", id: "4" },
      ],
    };
  },
  props: ["active"],
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./bottomNav.scss";
</style>
